import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';

const data = [
    {
        icon: <TerminalOutlinedIcon />,
        title: "SAP Software Developer",
        company: "SP Group",
        employmentType: "Internship",
        year: "2025",
        date: "Jan 2025 - Jun 2025",
        description: "• Developed SAP ABAP reporting programs to solve user pain points in data retrieval by delivering flexible tools for querying large datasets. \n"+
                        "• Collaborated with stakeholders to gather and refine requirements, translating user needs into functional reporting features that improved data accessibility and usability. \n"+
                        "• Improved knowledge access by co-developing an internal AI-powered tool using Microsoft Copilot Studio, raising user effort scores by 60%. \n"+
                        "• Drafted and formalised a security testing plan, aligning technical execution with organisational policy and stakeholder requirements. \n",
        location: "Singapore",
        current: false
    },{
        icon: <TerminalOutlinedIcon />,
        title: "Application Developer Intern",
        company: "ITLink Business Solutions (Singapore)",
        employmentType: "Internship",
        year: "2024",
        date: "May 2024 - Dec 2024",
        description: "• Developed and optimised Python scripts for project requirements, ensuring accurate end results. \n"+
                        "• Integrated Python scripts with IBM Planning Analytics (TM1) using TM1py, enhancing data processing and analysis. \n"+
                        "• Quickly mastered TM1 despite having no prior experience, demonstrating strong learning agility and adaptability. \n"+
                        "• Proactively identified and addressed inconsistencies in data, improving overall project quality. \n"+
                        "• Provided regular progress updates to the Project Manager, ensuring transparency and clear communication. \n"+
                        "• Demonstrated strong analytical ability, multitasking skills, and the ability to work independently to meet deadlines.",
        location: "Singapore",
        current: false
    },
    {
        icon: <VolunteerActivismOutlinedIcon />,
        title: "Silver Generation Ambassador",
        company: "Silver Generation Office",
        employmentType: "Volunteering",
        year: "2023",
        date: "Sep 2023 - Current",
        description: "• Build lasting relationships with seniors by sharing government policies and schemes that benefit them. \n"+
                        "• Guide seniors on health needs. \n"+
                        "• Share and explore ways with seniors to help them achieve their goals and aspirations.",
        location: "Singapore",
        current: true
    },
    {
        icon: <PrecisionManufacturingOutlinedIcon />,
        title: "Fulfilment Centre Supervisor",
        company: "Manpower Singapore",
        employmentType: "Contract",
        year: "2022",
        date: "Feb 2022 - Jul 2022",
        description: "• Carried out daily management of department duties, and communicating with internal and external suppliers. \n"+
                        "• Introduced new ideas leading to improved workflow and efficiency for both supervisors and associates. \n"+
                        "• Liaised with trainers, new hires and operation team, resulting in successful onboarding of new hires without impacting daily operations. \n"+
                        "• Provided policy follow-up, attendance tracking and reporting of labour hours. \n"+
                        "• Ensured area performance, through monitoring, reporting and feedback of associate performance. \n"+
                        "• Coached associates to work safely at all times, minimising work incidents. \n"+
                        "• Preparing daily and weekly reports regarding day-to-day operations. \n"+
                        "• Communicated with fellow supervisors to ensure smooth handover between shifts.",
        location: "Singapore",
        current: false
    },
    {
        icon: <PrecisionManufacturingOutlinedIcon />,
        title: "Warehouse Associate",
        company: "Amazon",
        employmentType: "Part-time",
        year: "2021",
        date: "Nov 2021 - Jan 2022",
        description: "• Sorting of goods into sortables and non-sortables according to different shipments. \n"+
                        "• Verifying data record on a computer database. \n"+
                        "• Building of carts for stowers to stow. \n"+
                        "• Receiving and stowing of goods.",
        location: "Singapore",
        current: false
    }
]

export default data;
